import React, { useState, useEffect } from 'react';
import { MainContainer } from '../../Home/HomeStyles';
import styled from 'styled-components';

const styles = {
  container: {
    maxWidth: '1200px',
    marginLeft: '0',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#333',
  },
  filterContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
  },
  input: {
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    backgroundColor: '#f8f9fa',
    padding: '12px',
    textAlign: 'left',
    borderBottom: '2px solid #dee2e6',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #dee2e6',
  },
  summary: {
    marginTop: '20px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'space-around',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
  },
  pageButton: {
    padding: '10px',
    margin: '0 5px',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  pageButtonDisabled: {
    padding: '10px',
    margin: '0 5px',
    backgroundColor: '#ddd',
    color: '#aaa',
    border: 'none',
    borderRadius: '4px',
    cursor: 'not-allowed',
  },
};

const ToggleButton = styled.button`
  margin-bottom: 10px;
  padding: 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
`;
export default function PointDetailView() {
  const [pointHistory, setPointHistory] = useState([]);
  const [startDateInput, setStartDateInput] = useState('');
  const [endDateInput, setEndDateInput] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [totalPoints, setTotalPoints] = useState(0);
  const [currentBalance, setCurrentBalance] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchPointHistory(currentPage);
    fetchCurrentBalance();
  }, [currentPage, startDate, endDate]);

  const fetchPointHistory = async (page = 1) => {
    try {
      const response = await fetch(
        `/Acution/points-history?startDate=${startDate}&endDate=${endDate}&page=${page}&limit=10`,
        { credentials: 'include' }
      );
      const data = await response.json();
      if (data && data.pointsHistory) {
        setPointHistory(data.pointsHistory);
        calculateTotalPoints(data.pointsHistory);
        setTotalPages(data.totalPages);
        setCurrentPage(data.currentPage);
      } else {
        console.error('포인트 내역을 가져올 수 없습니다.');
      }
    } catch (error) {
      console.error('포인트 내역 조회 중 오류 발생:', error);
    }
  };

  const fetchCurrentBalance = async () => {
    try {
      const response = await fetch('/Acution/points-balance', {
        credentials: 'include',
      });
      const data = await response.json();
      if (data.points_balance !== undefined) {
        setCurrentBalance(data.points_balance);
      } else {
        console.error('포인트 잔액을 가져올 수 없습니다.');
      }
    } catch (error) {
      console.error('포인트 잔액 조회 중 오류 발생:', error);
    }
  };

  const handleFilter = () => {
    setStartDate(startDateInput);
    setEndDate(endDateInput);
    setCurrentPage(1);
  };

  const calculateTotalPoints = (data) => {
    const total = data.reduce((acc, curr) => acc + curr.points, 0);
    setTotalPoints(total);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <MainContainer>
      <div style={styles.container}>
        <header style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '50%' }}>
            <h2 style={styles.title}>포인트 상세 내역</h2>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', width: '50%' }}>
            <div style={styles.filterContainer}>
              <input
                style={styles.input}
                type="date"
                value={startDateInput}
                onChange={(e) => setStartDateInput(e.target.value)}
                placeholder="시작 날짜"
              />
              <input
                style={styles.input}
                type="date"
                value={endDateInput}
                onChange={(e) => setEndDateInput(e.target.value)}
                placeholder="종료 날짜"
              />
              <button style={styles.button} onClick={handleFilter}>
                조회
              </button>
            </div>
          </div>
        </header>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>날짜</th>
              <th style={styles.th}>내용</th>
              <th style={styles.th}>포인트 변동</th>
              <th style={styles.th}>잔액</th>
            </tr>
          </thead>
          <tbody>
            {pointHistory.map((item, index) => (
              <tr key={index}>
                <td style={styles.td}>{new Date(item.created_at).toLocaleString()}</td>
                <td style={styles.td}>{item.content}</td>
                <td style={styles.td}>{item.points > 0 ? `+${item.points}` : item.points}</td>
                <td style={styles.td}>{item.balance}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={styles.summary}>
          <p>현재 포인트 잔액: {currentBalance}</p>
          <p>총 포인트 변동: {totalPoints > 0 ? `+${totalPoints}` : totalPoints}</p>
        </div>
        <div style={styles.pagination}>
          <button
            style={currentPage === 1 ? styles.pageButtonDisabled : styles.pageButton}
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
          >
            이전
          </button>
          <span>
            {currentPage} / {totalPages}
          </span>
          <button
            style={currentPage === totalPages ? styles.pageButtonDisabled : styles.pageButton}
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            다음
          </button>
        </div>
      </div>
    </MainContainer>
  );
}